// extracted by mini-css-extract-plugin
export var infoItem = "_ni-2";
export var title = "_ni-0";
export var value = "_ni-1";